<template>
  <div>
    <van-popup v-model="isShowiMmage" class="image-alert">
      <img :src="modelImageSrc" alt="" />
    </van-popup>
    <PageContent :dataList="listData" title="企业信息" ref="pageContentRef">
      <template v-slot="itemData">
        <div class="enterPriseInfo">
          <template>
            <div class="item">
              <div class="item-icon"></div>
              <span class="title-item"> 生产商:</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.business_name }}</span>
            </div>
          </template>
          <template>
            <div class="item p-top">
              <div class="item-icon"></div>
              <span class="title-item"> 地址:</span>
            </div>
            <div class="content-item">
              <span>{{
                itemData.itemData.op.op.province +
                itemData.itemData.op.op.city +
                itemData.itemData.op.op.region +
                itemData.itemData.op.op.addressdetail
              }}</span>
            </div>
          </template>
          <template>
            <div class="item p-top">
              <div class="item-icon"></div>
              <span class="title-item"> 联系电话:</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.phone }}</span>
            </div>
          </template>
          <template>
            <div class="item p-top">
              <div class="item-icon"></div>
              <span class="title-item"> 生产许可证编号:</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.license_number }}</span>
            </div>
          </template>
          <template>
            <div class="item p-top">
              <div class="item-icon"></div>
              <span class="title-item"> 执行标准:</span>
            </div>
            <div class="content-item">
              <span>{{ itemData.itemData.op.op.executive_standard }}</span>
            </div>
          </template>
        </div>
      </template>
    </PageContent>
    <div class="corporate_logo">
      <div class="corporate_logo_inner">
        <div class="corporate_logo_image_title">
          <div class="info_fold_line_cor"></div>
          <span>企业标识</span>
        </div>
        <div class="corporate_logo_image_container">
          <div
            class="enterprise_image_list"
            @click="swichImage(index)"
            v-for="(item, index) in corporateLogoList"
            :key="index"
          >
            <img :src="item.value" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="listsTg"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
      "
    >
      <div
        class="btn"
        v-for="(items, indexs) in listsTg"
        :key="indexs"
        @click="isShowModel(items.value)"
      >
        {{ items.key }}
      </div>
    </div>
  </div>
  <!-- @/assets/images/address.png -->
  <!-- @/assets/images/phone.png -->
</template>

<script>
import Vue from "vue";
import { Popup, Toast } from "vant";
Vue.use(Popup);
Vue.use(Toast);
export default {
  data() {
    return {
      listData: {},
      tel: "",
      listsTg: null,
      isShowiMmage: false,
      modelImageSrc: "",
      corporateLogoList: [],
    };
  },
  components: {},
  //生命周期 - 创建完成（访问当前this实例）
  // async created() {
  //    const {data:res} = await this.$api.getDataApi()
  //    this.options = res.chainBussinessTea
  // },
  //生命周期 - 挂载完成（访问DOM元素）
  created() {
    try {
      this.$setApptitle("链白茶防伪溯源");
    } catch {
      console.log("not webview");
    }
    this.defaultId = this.$route.query.defaultId;
    this.listData = JSON.parse(localStorage.getItem("idInObj"))[3];
    // 从本地获取推广配置信息
    this.listsTg = JSON.parse(localStorage.getItem("lists"));
    // 获取本地企业标识图片列表
    this.corporateLogoList = JSON.parse(
      localStorage.getItem("corporateLogoImageList")
    );
    console.log(this.listsTg);
    // let getItem = JSON.parse(localStorage.getItem('getItemVal'))
    // console.log(getItem.v)
    // this.options = getItem.v
    // this.tel = `tel: ${this.options.chainBussinessTea.phone}`
  },
  mounted() {
    // this.resetObj("[123,3456],[{a:2},{rrtg:订单}]");
  },
  //方法
  methods: {
    swichImage(index) {
      let imags = this.corporateLogoList.map((v) => v.value);
      this.switch_image(imags, index);
    },
    isShowModel(value) {
      if (!value) return Toast("企业未上传相关信息");
      this.isShowiMmage = true;
      this.modelImageSrc = value;
    },
    // resetObj(str) {
    //   let resetArr = [];
    //   let reset = str.replaceAll("],", "]?");
    //   let arr = reset.split("?");
    //   console.log(arr);
    //   arr.map((res) => {
    //     let oneRest = res.replaceAll(`"`, "`");
    //     let twoRest = oneRest.replaceAll("{", `{"`);
    //     let respons = twoRest.replaceAll(":", `":`);
    //     let respons1 = respons.replaceAll(`:`, `:"`);
    //     let respons2 = respons1.replaceAll("}", `"}`);
    //     console.log(respons2);
    //     resetArr.push(JSON.parse(respons2));
    //   });
    //   console.log(resetArr)
    //   return resetArr;
    // },
  },
};
</script>
<style lang="scss" scoped>
.goods-info-box {
  margin-bottom: 0 !important
  
  ;
}
.enterPriseInfo {
  .item {
    // margin-bottom: 54px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    color: #222222;
    .item-icon {
      width: 8px;
      height: 8px;
      background-color: #26907a;
      margin-right: 16px;
    }
    span.title-item {
      color: #222222;
      font-size: 28px;
      font-weight: bold;
    }
    img {
      float: right;
      width: 40px;
      height: 40px;
    }
  }
}
.btn {
  width: 510px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background-color: #26907a;
  border-radius: 16px;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-top: 40px;
}
.btn:not(:first-child) {
  margin-top: 20px;
}
.content-item {
  margin-top: 15px;
  padding-bottom: 16px;
  padding-left: 20px;
  border-bottom: 1px solid #d4d6d5;
  span {
    height: 40px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 40px;
    color: #808080;
  }
}
.p-top {
  padding-top: 14px;
}
::v-deep .goods-info-content {
  padding-right: 20px;
  padding-left: 20px;
}
.image-alert {
  img {
    width: 300px;
    height: 300px;
  }
}
.corporate_logo {
  padding: 24px 20px;
  .corporate_logo_inner {
    width: 100%;
    background-color: #f5f5f5;
    border-radius: 16px;
    box-shadow: 0px 4px 8px rgba(0, 45, 41, 0.2);
    .corporate_logo_image_title {
      padding: 32px 20px;
      display: flex;
      align-items: center;
      span {
        font-size: 34px;
        line-height: 34px;
      }
      .info_fold_line_cor {
        background-color: #26907a;
        width: 8px;
        height: 32px;
        margin-right: 16px;
      }
    }
    .corporate_logo_image_container {
      padding: 0 20px;
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .enterprise_image_list {
        margin-bottom: 30px;
        width: 270px;
        height: 160px;
        // background-color: #bcbcbc;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
